import apiClient from "../http/apiClient";
import { INVENTORY_ENDPOINTS } from "../http/endpoints";

function detailUrl(basePath, id) {
  return `${basePath}${id}/`;
}
function applyUrl(basePath, id) {
  return `${basePath}${id}/apply/`;
}
function cancelUrl(basePath, id) {
  return `${basePath}${id}/cancel/`;
}
function submitUrl(basePath, id) {
  return `${basePath}${id}/submit/`;
}
function reviewStartUrl(basePath, id) {
  return `${basePath}${id}/review/start/`;
}
function groupsUrl(basePath, id) {
  return `${basePath}${id}/groups/`;
}
function groupUrl(basePath, id, groupId) {
  return `${basePath}${id}/groups/${groupId}/`;
}
function groupJoinUrl(basePath, id, groupId) {
  return `${basePath}${id}/groups/${groupId}/join/`;
}
function crossesUrl(basePath, id) {
  return `${basePath}${id}/crosses/`;
}
function crossVoidUrl(basePath, id, crossId) {
  return `${basePath}${id}/crosses/${crossId}/void/`;
}
function itemDetailUrl(basePath, id, itemId) {
  return `${basePath}${id}/items/${itemId}/`;
}
function itemResetUrl(basePath, id, itemId) {
  return `${basePath}${id}/items/${itemId}/reset/`;
}
function itemEntriesUrl(basePath, id, itemId) {
  return `${basePath}${id}/items/${itemId}/entries/`;
}
function itemEntryUrl(basePath, id, itemId, entryId) {
  return `${basePath}${id}/items/${itemId}/entries/${entryId}/`;
}
function itemEntryVoidUrl(basePath, id, itemId, entryId) {
  return `${basePath}${id}/items/${itemId}/entries/${entryId}/void/`;
}

export async function listInboundNotes(params = {}) {
  const response = await apiClient.get(INVENTORY_ENDPOINTS.inboundNotes, { params });
  return response.data;
}

export async function getInboundNote(id, params = {}) {
  const response = await apiClient.get(detailUrl(INVENTORY_ENDPOINTS.inboundNotes, id), { params });
  return response.data;
}

export async function createInboundNote(payload) {
  const response = await apiClient.post(INVENTORY_ENDPOINTS.inboundNotes, payload);
  return response.data;
}

export async function updateInboundNoteItem(noteId, itemId, payload = {}) {
  const response = await apiClient.patch(itemDetailUrl(INVENTORY_ENDPOINTS.inboundNotes, noteId, itemId), payload);
  return response.data;
}

export async function deleteInboundNoteItem(noteId, itemId, params = {}) {
  const response = await apiClient.delete(itemDetailUrl(INVENTORY_ENDPOINTS.inboundNotes, noteId, itemId), { params });
  return response.data;
}

export async function listOutboundNotes(params = {}) {
  const response = await apiClient.get(INVENTORY_ENDPOINTS.outboundNotes, { params });
  return response.data;
}

export async function getOutboundNote(id, params = {}) {
  const response = await apiClient.get(detailUrl(INVENTORY_ENDPOINTS.outboundNotes, id), { params });
  return response.data;
}

export async function createOutboundNote(payload) {
  const response = await apiClient.post(INVENTORY_ENDPOINTS.outboundNotes, payload);
  return response.data;
}

export async function listStocks(params = {}) {
  const response = await apiClient.get(INVENTORY_ENDPOINTS.stocks, { params });
  return response.data;
}

export async function getStock(params = {}) {
  const data = await listStocks(params);
  const rows = Array.isArray(data) ? data : data?.results || [];
  const presentationId = Number(params?.product_presentation_id);
  if (Number.isInteger(presentationId) && presentationId > 0) {
    return (
      rows.find((row) => Number(row?.product_presentation_id) === presentationId) || null
    );
  }
  return rows[0] || null;
}

export async function listStockMovements(params = {}) {
  const response = await apiClient.get(INVENTORY_ENDPOINTS.stockMovements, { params });
  return response.data;
}

export async function createStockCount(payload = {}) {
  const response = await apiClient.post(INVENTORY_ENDPOINTS.stockCounts, payload);
  return response.data;
}

export async function getCountSettings(params = {}) {
  const response = await apiClient.get(INVENTORY_ENDPOINTS.countSettings, { params });
  return response.data;
}

export async function updateCountSettings(payload = {}) {
  const response = await apiClient.patch(INVENTORY_ENDPOINTS.countSettings, payload);
  return response.data;
}

export async function listStockCounts(params = {}) {
  const response = await apiClient.get(INVENTORY_ENDPOINTS.stockCounts, { params });
  return response.data;
}

export async function getStockCount(id, params = {}) {
  const response = await apiClient.get(detailUrl(INVENTORY_ENDPOINTS.stockCounts, id), { params });
  return response.data;
}

export async function listStockCountGroups(countId, params = {}) {
  const response = await apiClient.get(groupsUrl(INVENTORY_ENDPOINTS.stockCounts, countId), { params });
  return response.data;
}

export async function createStockCountGroup(countId, payload = {}) {
  const response = await apiClient.post(groupsUrl(INVENTORY_ENDPOINTS.stockCounts, countId), payload);
  return response.data;
}

export async function addStockCountGroupMember(countId, groupId, payload = {}) {
  const response = await apiClient.patch(groupUrl(INVENTORY_ENDPOINTS.stockCounts, countId, groupId), payload);
  return response.data;
}

export async function joinStockCountGroup(countId, groupId, payload = {}) {
  const response = await apiClient.post(groupJoinUrl(INVENTORY_ENDPOINTS.stockCounts, countId, groupId), payload);
  return response.data;
}

export async function listStockCountCrosses(countId, params = {}) {
  const response = await apiClient.get(crossesUrl(INVENTORY_ENDPOINTS.stockCounts, countId), { params });
  return response.data;
}

export async function createStockCountCross(countId, payload = {}) {
  const response = await apiClient.post(crossesUrl(INVENTORY_ENDPOINTS.stockCounts, countId), payload);
  return response.data;
}

export async function voidStockCountCross(countId, crossId, payload = {}) {
  const response = await apiClient.post(crossVoidUrl(INVENTORY_ENDPOINTS.stockCounts, countId, crossId), payload);
  return response.data;
}

export async function updateStockCountItem(countId, itemId, payload = {}) {
  const response = await apiClient.patch(itemDetailUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId), payload);
  return response.data;
}

export async function deleteStockCountItem(countId, itemId, params = {}) {
  const response = await apiClient.delete(itemDetailUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId), { params });
  return response.data;
}

export async function resetStockCountItem(countId, itemId, params = {}) {
  const response = await apiClient.delete(itemResetUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId), { params });
  return response.data;
}

export async function listStockCountEntries(countId, itemId, params = {}) {
  const response = await apiClient.get(itemEntriesUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId), { params });
  return response.data;
}

export async function createStockCountEntry(countId, itemId, payload = {}) {
  const response = await apiClient.post(itemEntriesUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId), payload);
  return response.data;
}

export async function updateStockCountEntry(countId, itemId, entryId, payload = {}) {
  const response = await apiClient.patch(itemEntryUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId, entryId), payload);
  return response.data;
}

export async function voidStockCountEntry(countId, itemId, entryId, payload = {}) {
  const response = await apiClient.post(itemEntryVoidUrl(INVENTORY_ENDPOINTS.stockCounts, countId, itemId, entryId), payload);
  return response.data;
}

export async function submitStockCount(id, payload = {}) {
  const response = await apiClient.post(submitUrl(INVENTORY_ENDPOINTS.stockCounts, id), payload);
  return response.data;
}

export async function startStockCountReview(id, payload = {}) {
  const response = await apiClient.post(reviewStartUrl(INVENTORY_ENDPOINTS.stockCounts, id), payload);
  return response.data;
}

export async function applyStockCount(id, payload = {}) {
  const response = await apiClient.post(applyUrl(INVENTORY_ENDPOINTS.stockCounts, id), payload);
  return response.data;
}

export async function cancelStockCount(id, payload = {}) {
  const response = await apiClient.post(cancelUrl(INVENTORY_ENDPOINTS.stockCounts, id), payload);
  return response.data;
}

export const inventoryService = {
  listInboundNotes,
  getInboundNote,
  createInboundNote,
  updateInboundNoteItem,
  deleteInboundNoteItem,
  listOutboundNotes,
  getOutboundNote,
  createOutboundNote,
  listStocks,
  getStock,
  listStockMovements,
  getCountSettings,
  updateCountSettings,
  createStockCount,
  listStockCounts,
  getStockCount,
  listStockCountGroups,
  createStockCountGroup,
  addStockCountGroupMember,
  joinStockCountGroup,
  listStockCountCrosses,
  createStockCountCross,
  voidStockCountCross,
  updateStockCountItem,
  deleteStockCountItem,
  resetStockCountItem,
  listStockCountEntries,
  createStockCountEntry,
  updateStockCountEntry,
  voidStockCountEntry,
  submitStockCount,
  startStockCountReview,
  applyStockCount,
  cancelStockCount,
};

export default inventoryService;
